import { useState } from "react";
import { Activity, Lock, Mail, LogIn } from "lucide-react";
import { useApp } from "../lib/store";
import { toast } from "sonner";

export default function Login() {
  const { login } = useApp();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await login(email.trim(), password);
      toast.success(`Welcome, ${u.name}`);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    } finally { setBusy(false); }
  };

  const quick = (em, pw) => { setEmail(em); setPassword(pw); };

  return (
    <div className="min-h-screen flex items-center justify-center p-4" style={{ background: "var(--bg)" }}>
      <div className="w-full max-w-md">
        <div className="flex items-center gap-3 mb-8 justify-center">
          <div className="w-11 h-11 rounded-xl brand-bg flex items-center justify-center"><Activity size={24} className="text-white" /></div>
          <div>
            <h1 className="font-display font-bold text-xl leading-tight">Media Team KRA</h1>
            <p className="text-xs text-muted-c tracking-wide">PERFORMANCE MANAGEMENT · FY 2026-27</p>
          </div>
        </div>
        <div className="card-panel p-7" data-testid="login-card">
          <h2 className="font-display font-semibold text-lg mb-1">Sign in</h2>
          <p className="text-sm text-secondary mb-5">Access your KRAs, tasks and performance.</p>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="text-xs font-semibold text-muted-c uppercase tracking-wider block mb-1.5">Email</label>
              <div className="relative">
                <Mail size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-c" />
                <input data-testid="login-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="input-c" style={{ paddingLeft: "2.4rem" }} placeholder="you@mediahq.com" />
              </div>
            </div>
            <div>
              <label className="text-xs font-semibold text-muted-c uppercase tracking-wider block mb-1.5">Password</label>
              <div className="relative">
                <Lock size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-c" />
                <input data-testid="login-password-input" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="input-c" style={{ paddingLeft: "2.4rem" }} placeholder="••••••••" />
              </div>
            </div>
            <button data-testid="login-submit-button" disabled={busy} className="w-full pill justify-center px-4 py-2.5 text-sm font-semibold brand-bg text-white disabled:opacity-60">
              <LogIn size={16} /> {busy ? "Signing in…" : "Sign in"}
            </button>
          </form>
          <div className="mt-6 pt-5 border-t border-subtle">
            <p className="text-[11px] uppercase tracking-wider text-muted-c mb-2">Quick sign-in (demo)</p>
            <div className="flex flex-wrap gap-2">
              <button onClick={() => quick("priyank@mediahq.com", "Priyank@2026")} className="pill px-2.5 py-1 text-xs border-subtle text-secondary hover:brand-text" data-testid="quick-admin">Super Admin</button>
              <button onClick={() => quick("anjali@mediahq.com", "Anjali@2026")} className="pill px-2.5 py-1 text-xs border-subtle text-secondary hover:brand-text" data-testid="quick-manager">Manager (Anjali)</button>
              <button onClick={() => quick("lahar@mediahq.com", "Lahar@2026")} className="pill px-2.5 py-1 text-xs border-subtle text-secondary hover:brand-text" data-testid="quick-hr">HR (Lahar)</button>
              <button onClick={() => quick("om@mediahq.com", "Om@2026")} className="pill px-2.5 py-1 text-xs border-subtle text-secondary hover:brand-text" data-testid="quick-employee">Employee (Om)</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
